<template>
    <div class="pps-limit-modal" v-if="show" v-bsl="true">
        <div class="limit__blur" @click="show = false"></div>
        <div class="limit__alert">
            <div
                class="limit__alert-conditions"
                v-if="conditionQuantity || conditionQuantityForOuterwear.quantity > maxQuantityForOuterwear">
                <div class="conditions__title">{{ $t("limit_modal_delivery_title") }}:</div>
                <div class="conditions__item" v-if="conditionQuantity">
                    - {{ $t("limit_modal_delivery_condition1") }}
                </div>
                <div class="conditions__item" v-if="conditionQuantityForOuterwear.quantity > maxQuantityForOuterwear">
                    - {{ $t("limit_modal_preorder_condition1") }}
                    <template>
                        (<span style="color: red">{{ conditionQuantityForOuterwear.items.join(",") }}</span
                        >)
                    </template>
                </div>
            </div>
            <div class="limit__alert-conditions" v-if="conditionCopiesOfModelInSameSize">
                <div class="conditions__title">{{ $t("limit_modal_preorder_title") }}:</div>
                <div class="conditions__item" v-if="conditionCopiesOfModelInSameSize">
                    - {{ $t("limit_modal_preorder_condition2") }}
                </div>
            </div>
            <div
                style="margin-top: 20px"
                class="button button--dark button--large"
                @click="show = false">
                {{ $t("limit_modal_apply") }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "CartLimitModal",
    data() {
        return {
            show: false,
            conditionQuantity: false,
            conditionCopiesOfModelInSameSize: false,
            conditionQuantityForOuterwear: {},
            maxQuantityForOuterwear: 3,
            maxQuantity: 7,
            maxCopiesOfModelInSameSize: 2,
        };
    },
    computed: {
        ...mapGetters({
            orderItems: "order/getItems",
            liveItems: "order/getLiveItems",
        }),
        orderLiveItems() {
            return this.orderItems && this.liveItems;
        },
    },
    watch: {
        orderLiveItems() {
            this.check();
        },
    },
    created() {
        this.check();
    },
    methods: {
        quantityLimitProducts() {
            const orderItems = this.orderItems;
            let quantity = 0;
            let quantityCopiesOfModelInSameSize = 0;

            for (let key in orderItems) {
                let countItem = orderItems[key].count;

                quantity += countItem;

                if (countItem > this.maxCopiesOfModelInSameSize) {
                    quantityCopiesOfModelInSameSize += 1;
                }
            }

            quantity > this.maxQuantity && this.$route.name == "zakaz"
                ? (this.conditionQuantity = true)
                : (this.conditionQuantity = false);
            quantityCopiesOfModelInSameSize >= 1
                ? (this.conditionCopiesOfModelInSameSize = true)
                : (this.conditionCopiesOfModelInSameSize = false);
        },
        quantityOuterwear() {
            const liveItems = this.liveItems;
            const orderItems = this.orderItems;
            let items = [];
            let quantity = 0;

            if (liveItems) {
                for (let key in liveItems) {
                    const isOuterwear = liveItems[key].product.category.is_outerwear;

                    if (isOuterwear) {
                        quantity += orderItems[liveItems[key].id].count;
                        items.push(liveItems[key].product.name);
                    }
                }
            }

            return (this.conditionQuantityForOuterwear = {
                quantity: quantity,
                items: items,
            });
        },
        check() {
            this.quantityOuterwear();
            this.quantityLimitProducts();

            let disabledPpsCourier =
                this.conditionQuantity || this.conditionQuantityForOuterwear.quantity > this.maxQuantityForOuterwear;
            let disabledPpsPreorderPayment = this.conditionCopiesOfModelInSameSize;

            if (this.conditionCopiesOfModelInSameSize && !sessionStorage.getItem("conditionCopiesOfModelInSameSize")) {
                this.show = true;
                sessionStorage.setItem("conditionCopiesOfModelInSameSize", true);
            }

            if (this.conditionQuantity && !sessionStorage.getItem("conditionQuantity")) {
                this.show = true;
                sessionStorage.setItem("conditionQuantity", true);
            }

            if (
                this.conditionQuantityForOuterwear.quantity > this.maxQuantityForOuterwear &&
                !sessionStorage.getItem("conditionQuantityForOuterwear")
            ) {
                this.show = true;
                sessionStorage.setItem("conditionQuantityForOuterwear", true);
            }

            this.$store.commit("globalvars/setStatusPpsCourier", disabledPpsCourier);
            this.$store.commit("globalvars/setStatusPpsCourierPreorderPayment", disabledPpsPreorderPayment);
        },
    },
};
</script>

<style scoped lang="less">
.pps-limit-modal {
    position: absolute;
    width: 100%;
    height: 100%;
    .limit__blur {
        width: 100%;
        height: 100%;
        background: black;
        opacity: 0.1;
        z-index: 20;
        position: fixed;
        top: 0;
        left: 0;
    }
    .limit__alert {
        top: 50%;
        left: 50%;
        width: 80%;
        position: fixed;
        z-index: 21;
        transform: translate(-50%, -50%);
        background: #f9f9f9;
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 400px;
        gap: 10px;

        &-conditions {
            text-align: center;
            width: 100%;
        }
        .conditions__title {
            font-weight: bold;
        }
        .conditions__item {
            margin-top: 10px;
        }
    }
}
</style>
